import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setJiraServerId: YJSChangeHandler<DatabaseChangeType.SET_JIRA_SERVER_ID> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.jiraServerId = change.jiraServerId;
  });
};
